export const API_ENDPOINTS = {
    LOGIN: '/admin/login',
    REFRESH_TOKEN: '/users/refresh-token',
    ADD_ADMIN_USER : '/admin/create',
    LIST_ADMIN_USERS : '/admin/all',
    GET_ADMIN_USER_BY_ID : (id) => `/admin/${id}`,
    UPDATE_ADMIN_USER : (username) => `/admin/update/${username}`,
    DELETE_ADMIN_USER : (id) => `/admin/delete/${id}`,
    ADD_USER: '/users/create',
    CREATE_USER_PROFILE: '/users/profile',
    UPDATE_USER_PROFILE: '/users/profile',
    GET_ALL_USER_PROFILES: '/users/profile',
    GET_USER_PROFILE : (email) => `/users/profile/${email}`,
    GET_ALL_USERS : '/users/all',
    GET_ALL_STUDENTS : '/users/students',
    GET_USER_BY_ID: (id) => `/users/${id}`,
    GET_INSTRUCTORS : '/users/instructors',
    UPDATE_USER:  '/users/update',
    UPDATE_PASSWORD: '/users/update-password',
    DELETE_USER: (id) => `/users/delete/${id}`,

    GET_ALL_COURSES: '/courses/all',
    CREATE_COURSE: '/courses/create',
    UPDATE_COURSE: '/courses/update',
    DELETE_COURSE: (id) => `/courses/delete/${id}`,

    GET_ALL_QUIZZES: '/quizzes/all',
    CREATE_QUIZ: '/quizzes/create',
    UPDATE_QUIZ: '/quizzes/update',
    DELETE_QUIZ: (id) => `/quizzes/delete/${id}`,

    GET_ALL_LESSONS: '/lessons/all',
    GET_ALL_LESSONS_COURSE : (id) => `/lessons/${id}`,
    CREATE_LESSON: '/lessons/create',
    UPDATE_LESSON: (id) => `/lessons/update/${id}`,
    DELETE_LESSON: (id) => `/lessons/delete/${id}`,

    // Lesson Content endpoints
    CREATE_LESSON_CONTENT: '/lesson-contents/create',
    GET_LESSON_CONTENT_BY_ID: (contentId) => `/lesson-contents/${contentId}`,
    GET_LESSON_CONTENTS_BY_LESSON_ID: (lessonId) => `/lesson-contents/lesson/${lessonId}`,
    UPDATE_LESSON_CONTENT: (contentId) => `/lesson-contents/update/${contentId}`,
    DELETE_LESSON_CONTENT: (contentId) => `/lesson-contents/delete/${contentId}`,
    DELETE_ALL_LESSON_CONTENTS_BY_LESSON_ID: (lessonId) => `/lesson-contents/delete-all/${lessonId}`,
  

    GET_ALL_QUESTIONS: '/questions/all',
    CREATE_QUESTION: '/questions/create',
    UPDATE_QUESTION: '/questions/update',
    DELETE_QUESTION: (id) => `/questions/delete/${id}`,
    GET_QUESTION_BY_ID: (id) => `/questions/${id}`,
    GET_QUESTIONS_BY_QUIZ_ID: (quizId) => `/questions/quiz/${quizId}`,
    GET_QUESTIONS_BY_LESSON_ID: (lessonId) => `/questions/lesson/${lessonId}`,
    UPDATE_QUESTIONS_QUIZ_ID: `/questions/update-quiz`,
    
    GET_ALL_ANSWERS: '/questions/answer/all',
    CREATE_ANSWER: '/questions/answer/create',
    UPDATE_ANSWER: '/questions/answer/update',
    DELETE_ANSWER: (id) => `/questions/answer/delete/${id}`,
    GET_ANSWERS_BY_QUESTION_ID: (questionId) => `/questions/answer/${questionId}`,
    
    CREATE_ARTICLE : '/articles/create',
    UPDATE_ARTICLE : '/articles/update',
    DELETE_ARTICLE: (id) => `/articles/${id}`,
    GET_ALL_ARTICLES : '/articles/all',
    GET_ARTICLE_BY_ID : (id) => `/articles/${id}`,

    // Topic endpoints
    CREATE_TOPIC: '/topics/create',
    GET_TOPIC_BY_ID: (id) => `/topics/${id}`,
    GET_TOPICS_BY_COURSE_ID: (courseId) => `/topics/course/${courseId}`,
    GET_TOPICS_LESSONS_BY_COURSE_ID: (courseId, classId) => `/topics/with-lessons/${courseId}/${classId}`,
    GET_ALL_TOPICS: '/topics/all',
    UPDATE_TOPIC: (id) => `/topics/update/${id}`,
    DELETE_TOPIC: (id) => `/topics/delete/${id}`,

    // Topic Lesson endpoints
    CREATE_TOPIC_LESSON: '/topic-lessons/create',
    GET_TOPIC_LESSONS_BY_TOPIC_ID: (topicId) => `/topic-lessons/topic/${topicId}`,
    UPDATE_TOPIC_LESSON: (id) => `/topic-lessons/update/${id}`,
    DELETE_TOPIC_LESSON: (id) => `/topic-lessons/delete/${id}`,
    

    // Exam endpoints
    CREATE_EXAM: '/exams/create',
    GET_EXAM_BY_ID: (id) => `/exams/${id}`,
    GET_EXAMS_BY_COURSE_ID: (courseId) => `/exams/course/${courseId}`,
    GET_ALL_EXAMS: '/exams/all',
    GET_ACTIVE_EXAMS: '/exams/active',
    UPDATE_EXAM: (id) => `/exams/update/${id}`,
    DELETE_EXAM: (id) => `/exams/delete/${id}`,
    ACTIVATE_EXAM: (id) => `/exams/activate/${id}`,
    DEACTIVATE_EXAM: (id) => `/exams/deactivate/${id}`,

    // Exam Question endpoints
    CREATE_EXAM_QUESTION: '/exam-questions/create',
    GET_EXAM_QUESTIONS_BY_EXAM_ID: (examId) => `/exam-questions/exam/${examId}`,
    DELETE_EXAM_QUESTION: (id) => `/exam-questions/delete/${id}`,

    // Exam Result endpoints
    CREATE_EXAM_RESULT: '/exam-results/create',
    GET_EXAM_RESULTS_BY_USER_ID: (userId) => `/exam-results/user/${userId}`,
    GET_EXAM_RESULTS_BY_EXAM_ID: (examId) => `/exam-results/exam/${examId}`,

    // Exam Availability endpoints
    CREATE_EXAM_AVAILABILITY: '/exam-availability/create',
    GET_EXAM_AVAILABILITY_BY_EXAM_ID: (examId) => `/exam-availability/exam/${examId}`,
    DELETE_EXAM_AVAILABILITY: (id) => `/exam-availability/delete/${id}`,

    // Class endpoints
    CREATE_CLASS: '/classes/create',
    GET_CLASS_BY_ID: (id) => `/classes/${id}`,
    GET_CLASS_BY_CODE: (classCode) => `/classes/code/${classCode}`,
    GET_CLASSES_BY_COURSE_ID: (courseId) => `/classes/course/${courseId}`,
    GET_CLASSES_BY_INSTRUCTOR_ID: (instructorId) => `/classes/instructor/${instructorId}`,
    GET_ALL_CLASSES: '/classes/all',
    GET_CLASS_DASHBOARD: (classId) => `/classes/dashboard/${classId}`,
    UPDATE_CLASS: (id) => `/classes/update/${id}`,
    DELETE_CLASS: (id) => `/classes/delete/${id}`,
    CLASS_LESSON_CHECK_INSTRUCTOR: '/classes/check-instructor',
    CLASS_LESSON_DELETE_INSTRUCTOR: (lessonId, classId) => `/classes/delete-instructor/${lessonId}/${classId}`,

    // Class Student endpoints
    ENROLL_STUDENT: '/class-students/enroll',
    GET_STUDENTS_IN_CLASS: (classId) => `/class-students/class/${classId}`,
    GET_CLASSES_FOR_STUDENT: (studentId) => `/class-students/student/${studentId}`,
    DELETE_STUDENT_FROM_CLASS: (classId, studentId) => `/class-students/class/${classId}/student/${studentId}`,

    // Attendance endpoints
    MARK_ATTENDANCE: '/attendance/mark',
    GET_ATTENDANCE_FOR_CLASS: (classId) => `/attendance/class/${classId}`,
    GET_STUDENT_ATTENDANCE: (classId, studentId) => `/attendance/class/${classId}/student/${studentId}`,

    GET_ALL_CATEGORIES: '/categories/all',
    CREATE_CATEGORY: '/categories/create',
    UPDATE_CATEGORY: '/categories/update',
    DELETE_CATEGORY: (id) => `/categories/delete/${id}`,

    // LOS (Learning Outcome Standards) endpoints
    CREATE_LOS: '/los/create',
    GET_LOS_BY_ID: (id) => `/los/${id}`,
    GET_LOS_BY_LESSON_ID: (lessonId) => `/los/lesson/${lessonId}`,
    GET_ALL_LOS: '/los/all',
    UPDATE_LOS: (id) => `/los/update/${id}`,
    DELETE_LOS: (id) => `/los/delete/${id}`,
    DELETE_LOS_BY_LESSON_ID: (lessonId) => `/los/lesson/${lessonId}`,
    SEARCH_LOS: '/los/search',

    // Exam Type endpoints
    CREATE_EXAM_TYPE: '/exam-types/create',
    GET_EXAM_TYPE_BY_ID: (id) => `/exam-types/${id}`,
    GET_EXAM_TYPE_BY_NAME_AND_COURSE: (courseId, name) => `/exam-types/course/${courseId}/name/${encodeURIComponent(name)}`,
    GET_ALL_EXAM_TYPES: '/exam-types/all',
    GET_EXAM_TYPES_BY_COURSE_ID: (courseId) => `/exam-types/course/${courseId}`,
    UPDATE_EXAM_TYPE: (id) => `/exam-types/update/${id}`,
    DELETE_EXAM_TYPE: (id) => `/exam-types/delete/${id}`,
    DELETE_EXAM_TYPES_BY_COURSE_ID: (courseId) => `/exam-types/course/${courseId}`,
    SEARCH_EXAM_TYPES: '/exam-types/search',
    SEARCH_EXAM_TYPES_BY_COURSE: (courseId) => `/exam-types/course/${courseId}/search`,

    // Class Feedback endpoints
    CREATE_CLASS_FEEDBACK: '/class-feedback/create',
    GET_CLASS_FEEDBACK_BY_ID: (id) => `/class-feedback/${id}`,
    GET_CLASS_FEEDBACKS_BY_CLASS_ID: (classId) => `/class-feedback/class/${classId}`,
    GET_ACTIVE_CLASS_FEEDBACKS: '/class-feedback/active',
    UPDATE_CLASS_FEEDBACK: (id) => `/class-feedback/update/${id}`,
    ACTIVATE_CLASS_FEEDBACK: (id) => `/class-feedback/activate/${id}`,
    DELETE_CLASS_FEEDBACK: (id) => `/class-feedback/delete/${id}`,

    // Class Feedback Questions endpoints
    CREATE_FEEDBACK_QUESTION: '/class-feedback-questions/create',
    GET_FEEDBACK_QUESTIONS_BY_FEEDBACK_ID: (feedbackId) => `/class-feedback-questions/feedback/${feedbackId}`,
    UPDATE_FEEDBACK_QUESTION: (id) => `/class-feedback-questions/update/${id}`,
    DELETE_FEEDBACK_QUESTION: (id) => `/class-feedback-questions/delete/${id}`,

    // Class Feedback Responses endpoints
    CREATE_FEEDBACK_RESPONSE: '/class-feedback-responses/create',
    GET_FEEDBACK_RESPONSES_BY_FEEDBACK_ID: (feedbackId) => `/class-feedback-responses/feedback/${feedbackId}`,
    GET_FEEDBACK_RESPONSES_BY_USER_ID: (userId) => `/class-feedback-responses/user/${userId}`,
    UPDATE_FEEDBACK_RESPONSE: (id) => `/class-feedback-responses/update/${id}`,
    DELETE_FEEDBACK_RESPONSE: (id) => `/class-feedback-responses/delete/${id}`,

    // Class Feedback Data endpoints (combined data)
    GET_COMPLETE_FEEDBACK_DATA: (feedbackId) => `/class-feedback-data/feedback/${feedbackId}`,
    GET_USER_COMPLETE_FEEDBACK_DATA: (userId) => `/class-feedback-data/user/${userId}`,

    // User Answers endpoints
    GET_USER_ANSWERS_BY_CLASS_ID: (classId) => `/user-answers/dashboard/class/${classId}`,
    GET_INDIVIDUAL_DASHBOARD: (userId) => `/user-answers/dashboard/individual?user_id=${userId}`,

    // User Service endpoints
    CREATE_USER_SERVICE: '/user-services/create',
    GET_USER_SERVICE_BY_ID: (id) => `/user-services/${id}`,
    GET_USER_SERVICES_BY_USER_ID: (userId) => `/user-services/user/${userId}`,
    GET_ACTIVE_USER_SERVICES_BY_USER_ID: (userId) => `/user-services/user/${userId}/active`,
    GET_USER_SERVICE_BY_USER_AND_COURSE: (userId, courseId) => `/user-services/user/${userId}/course/${courseId}`,
    UPDATE_USER_SERVICE: (id) => `/user-services/${id}`,
    EXTEND_USER_SERVICE: (id) => `/user-services/${id}/extend`,
    DELETE_USER_SERVICE: (id) => `/user-services/${id}`,
    DELETE_USER_SERVICES_BY_USER_ID: (userId) => `/user-services/user/${userId}`,

    // Class Shared Files endpoints
    CREATE_CLASS_SHARED_FILE: '/class-shared-files/create',
    GET_ALL_CLASS_SHARED_FILES: '/class-shared-files/all',
    GET_CLASS_SHARED_FILE_BY_ID: (id) => `/class-shared-files/${id}`,
    GET_CLASS_SHARED_FILES_BY_CLASS_ID: (classId) => `/class-shared-files/class/${classId}`,
    GET_CLASS_SHARED_FILES_BY_UPLOADER: (uploaderId) => `/class-shared-files/uploader/${uploaderId}`,
    GET_CLASS_SHARED_FILES_BY_TYPE: (fileType) => `/class-shared-files/type/${fileType}`,
    GET_CLASS_SHARED_FILES_WITH_USER_DETAILS: '/class-shared-files/with-user-details',
    GET_CLASS_SHARED_FILE_WITH_USER_DETAILS: (id) => `/class-shared-files/${id}/with-user-details`,
    GET_RECENT_CLASS_SHARED_FILES: '/class-shared-files/recent',
    SEARCH_CLASS_SHARED_FILES: '/class-shared-files/search',
    COUNT_ALL_CLASS_SHARED_FILES: '/class-shared-files/count/all',
    COUNT_CLASS_SHARED_FILES_BY_CLASS: (classId) => `/class-shared-files/count/class/${classId}`,
    UPDATE_CLASS_SHARED_FILE: (id) => `/class-shared-files/${id}`,
    DELETE_CLASS_SHARED_FILE: (id) => `/class-shared-files/${id}`,
    DELETE_CLASS_SHARED_FILES_BY_CLASS: (classId) => `/class-shared-files/class/${classId}`,

    // Class Assignments endpoints
    CREATE_CLASS_ASSIGNMENT: '/class-assignments/create',
    GET_ALL_CLASS_ASSIGNMENTS: '/class-assignments/all',
    GET_CLASS_ASSIGNMENT_BY_ID: (id) => `/class-assignments/${id}`,
    GET_CLASS_ASSIGNMENTS_BY_CLASS_ID: (classId) => `/class-assignments/class/${classId}`,
    GET_CLASS_ASSIGNMENTS_BY_CREATOR: (creatorId) => `/class-assignments/creator/${creatorId}`,
    GET_CLASS_ASSIGNMENTS_BY_TYPE: (assignmentType) => `/class-assignments/type/${assignmentType}`,
    GET_UPCOMING_CLASS_ASSIGNMENTS: '/class-assignments/upcoming',
    GET_OVERDUE_CLASS_ASSIGNMENTS: '/class-assignments/overdue',
    GET_CLASS_ASSIGNMENTS_WITH_CREATOR_DETAILS: '/class-assignments/with-creator-details',
    GET_CLASS_ASSIGNMENT_WITH_CREATOR_DETAILS: (id) => `/class-assignments/${id}/with-creator-details`,
    SEARCH_CLASS_ASSIGNMENTS: '/class-assignments/search',
    COUNT_ALL_CLASS_ASSIGNMENTS: '/class-assignments/count/all',
    COUNT_CLASS_ASSIGNMENTS_BY_CLASS: (classId) => `/class-assignments/count/class/${classId}`,
    UPDATE_CLASS_ASSIGNMENT: (id) => `/class-assignments/${id}`,
    DELETE_CLASS_ASSIGNMENT: (id) => `/class-assignments/${id}`,
    DELETE_CLASS_ASSIGNMENTS_BY_CLASS: (classId) => `/class-assignments/class/${classId}`,

    // Assignment Submissions endpoints
    CREATE_ASSIGNMENT_SUBMISSION: '/assignment-submissions/create',
    GET_ALL_ASSIGNMENT_SUBMISSIONS: '/assignment-submissions/all',
    GET_ASSIGNMENT_SUBMISSION_BY_ID: (id) => `/assignment-submissions/${id}`,
    GET_ASSIGNMENT_SUBMISSIONS_BY_ASSIGNMENT: (assignmentId) => `/assignment-submissions/assignment/${assignmentId}`,
    GET_ASSIGNMENT_SUBMISSIONS_BY_USER: (userId) => `/assignment-submissions/user/${userId}`,
    GET_ASSIGNMENT_SUBMISSION_BY_ASSIGNMENT_AND_USER: (assignmentId, userId) => `/assignment-submissions/assignment/${assignmentId}/user/${userId}`,
    GET_ASSIGNMENT_SUBMISSIONS_BY_STATUS: (status) => `/assignment-submissions/status/${status}`,
    GET_PENDING_ASSIGNMENT_SUBMISSIONS: '/assignment-submissions/pending',
    GET_GRADED_ASSIGNMENT_SUBMISSIONS: '/assignment-submissions/graded',
    GET_ASSIGNMENT_SUBMISSIONS_WITH_USER_DETAILS: '/assignment-submissions/with-user-details',
    GET_ASSIGNMENT_SUBMISSION_WITH_DETAILS: (id) => `/assignment-submissions/${id}/with-details`,
    GET_ASSIGNMENT_SUBMISSIONS_WITH_USER_DETAILS_BY_ASSIGNMENT: (assignmentId) => `/assignment-submissions/assignment/${assignmentId}/with-user-details`,
    COUNT_ALL_ASSIGNMENT_SUBMISSIONS: '/assignment-submissions/count/all',
    COUNT_ASSIGNMENT_SUBMISSIONS_BY_ASSIGNMENT: (assignmentId) => `/assignment-submissions/count/assignment/${assignmentId}`,
    COUNT_ASSIGNMENT_SUBMISSIONS_BY_STATUS: (status) => `/assignment-submissions/count/status/${status}`,
    UPDATE_ASSIGNMENT_SUBMISSION: (id) => `/assignment-submissions/${id}`,
    GRADE_ASSIGNMENT_SUBMISSION: (id) => `/assignment-submissions/${id}/grade`,
    DELETE_ASSIGNMENT_SUBMISSION: (id) => `/assignment-submissions/${id}`,
    DELETE_ASSIGNMENT_SUBMISSIONS_BY_ASSIGNMENT: (assignmentId) => `/assignment-submissions/assignment/${assignmentId}`,

    // WEBDATA endpoints
    // Hero Section
    GET_ACTIVE_HERO: '/webdata/hero/active',
    GET_ALL_HEROES: '/webdata/hero/all',
    CREATE_HERO: '/webdata/hero/create',
    UPDATE_HERO: (id) => `/webdata/hero/${id}`,
    ACTIVATE_HERO: (id) => `/webdata/hero/${id}/activate`,
    DELETE_HERO: (id) => `/webdata/hero/${id}`,

    // Feature Cards
    GET_ACTIVE_FEATURE_CARDS: '/webdata/feature-cards/',
    GET_ALL_FEATURE_CARDS: '/webdata/feature-cards/all',
    GET_FEATURE_CARD_BY_ID: (id) => `/webdata/feature-cards/${id}`,
    CREATE_FEATURE_CARD: '/webdata/feature-cards/create',
    UPDATE_FEATURE_CARD: (id) => `/webdata/feature-cards/${id}`,
    TOGGLE_FEATURE_CARD: (id) => `/webdata/feature-cards/${id}/toggle`,
    DELETE_FEATURE_CARD: (id) => `/webdata/feature-cards/${id}`,

    // Important Dates
    GET_ACTIVE_IMPORTANT_DATES: '/webdata/important-dates/',
    GET_ALL_IMPORTANT_DATES: '/webdata/important-dates/all',
    GET_IMPORTANT_DATE_BY_ID: (id) => `/webdata/important-dates/${id}`,
    CREATE_IMPORTANT_DATE: '/webdata/important-dates/create',
    UPDATE_IMPORTANT_DATE: (id) => `/webdata/important-dates/${id}`,
    TOGGLE_IMPORTANT_DATE: (id) => `/webdata/important-dates/${id}/toggle`,
    DELETE_IMPORTANT_DATE: (id) => `/webdata/important-dates/${id}`,

    // Statistics
    GET_ACTIVE_STATISTICS: '/webdata/statistics/',
    GET_ALL_STATISTICS: '/webdata/statistics/all',
    GET_STATISTIC_BY_ID: (id) => `/webdata/statistics/${id}`,
    CREATE_STATISTIC: '/webdata/statistics/create',
    UPDATE_STATISTIC: (id) => `/webdata/statistics/${id}`,
    TOGGLE_STATISTIC: (id) => `/webdata/statistics/${id}/toggle`,
    DELETE_STATISTIC: (id) => `/webdata/statistics/${id}`,

    // Teachers
    GET_ACTIVE_TEACHERS: '/webdata/teachers/',
    GET_ALL_TEACHERS: '/webdata/teachers/all',
    GET_TEACHER_BY_ID: (id) => `/webdata/teachers/${id}`,
    CREATE_TEACHER: '/webdata/teachers/create',
    UPDATE_TEACHER: (id) => `/webdata/teachers/${id}`,
    TOGGLE_TEACHER: (id) => `/webdata/teachers/${id}/toggle`,
    DELETE_TEACHER: (id) => `/webdata/teachers/${id}`,

    // Collaborating Companies
    GET_ACTIVE_COMPANIES: '/webdata/companies/',
    GET_ALL_COMPANIES: '/webdata/companies/all',
    GET_COMPANY_BY_ID: (id) => `/webdata/companies/${id}`,
    CREATE_COMPANY: '/webdata/companies/create',
    UPDATE_COMPANY: (id) => `/webdata/companies/${id}`,
    TOGGLE_COMPANY: (id) => `/webdata/companies/${id}/toggle`,
    DELETE_COMPANY: (id) => `/webdata/companies/${id}`,

    // Web Courses
    GET_ACTIVE_WEB_COURSES: '/web-courses/active',
    GET_ALL_WEB_COURSES: '/web-courses/all',
    GET_WEB_COURSE_BY_ID: (id) => `/web-courses/${id}`,
    CREATE_WEB_COURSE: '/web-courses/create',
    UPDATE_WEB_COURSE: (id) => `/web-courses/${id}`,
    TOGGLE_WEB_COURSE: (id) => `/web-courses/${id}/toggle`,
    DELETE_WEB_COURSE: (id) => `/web-courses/${id}`,

    // Web Course Registration Forms
    GET_ACTIVE_COURSE_REGISTRATION_FORMS: '/web-course-registrations/forms/',
    GET_ALL_COURSE_REGISTRATION_FORMS: '/web-course-registrations/forms/all',
    GET_COURSE_REGISTRATION_FORM_BY_ID: (id) => `/web-course-registrations/forms/${id}`,
    CREATE_COURSE_REGISTRATION_FORM: '/web-course-registrations/forms/create',
    UPDATE_COURSE_REGISTRATION_FORM: (id) => `/web-course-registrations/forms/${id}`,
    TOGGLE_COURSE_REGISTRATION_FORM: (id) => `/web-course-registrations/forms/${id}/toggle`,
    DELETE_COURSE_REGISTRATION_FORM: (id) => `/web-course-registrations/forms/${id}`,

    // Form Questions
    GET_ALL_FORM_QUESTIONS: 'web-course-registrations/questions/form/',
    GET_FORM_QUESTION_BY_ID: (id) => `/form-questions/${id}`,
    GET_FORM_QUESTIONS_BY_FORM_ID: (formId) => `/web-course-registrations/questions/form/${formId}`,
    CREATE_FORM_QUESTION: '/web-course-registrations/questions/create',
    UPDATE_FORM_QUESTION: (id) => `/web-course-registrations/questions/${id}`,
    DELETE_FORM_QUESTION: (id) => `/web-course-registrations/questions/${id}`,
    DELETE_FORM_QUESTIONS_BY_FORM_ID: (formId) => `/web-course-registrations/questions/form/${formId}`,

    // Form Results (Submissions)
    GET_ALL_FORM_RESULTS: '/form-results/all',
    GET_FORM_RESULT_BY_ID: (id) => `/form-results/${id}`,
    GET_FORM_RESULTS_BY_FORM_ID: (formId) => `/web-course-registrations/results/form/${formId}`,
    GET_FORM_RESULTS_BY_USER_EMAIL: (email) => `/form-results/user/${email}`,
    CREATE_FORM_RESULT: '/form-results/create',
    UPDATE_FORM_RESULT: (id) => `/form-results/${id}`,
    DELETE_FORM_RESULT: (id) => `/form-results/${id}`,
    DELETE_FORM_RESULTS_BY_FORM_ID: (formId) => `/form-results/form/${formId}`,

    // Web Contact Us
    GET_ALL_CONTACT_MESSAGES: '/web-contact-us/all',
    GET_CONTACT_MESSAGE_BY_ID: (id) => `/web-contact-us/${id}`,
    GET_CONTACT_MESSAGES_BY_EMAIL: (email) => `/web-contact-us/email/${email}`,
    SEARCH_CONTACT_MESSAGES: (query) => `/web-contact-us/search?q=${query}`,
    CREATE_CONTACT_MESSAGE: '/web-contact-us/create',
    UPDATE_CONTACT_MESSAGE: (id) => `/web-contact-us/${id}`,
    DELETE_CONTACT_MESSAGE: (id) => `/web-contact-us/${id}`,

    // Web Course FAQs
    GET_ALL_WEB_COURSE_FAQS: '/web-course-faqs/all',
    GET_WEB_COURSE_FAQ_BY_ID: (id) => `/web-course-faqs/${id}`,
    GET_WEB_COURSE_FAQS_BY_COURSE_ID: (webCourseId) => `/web-course-faqs/web-course/${webCourseId}`,
    CREATE_WEB_COURSE_FAQ: '/web-course-faqs/create',
    UPDATE_WEB_COURSE_FAQ: (id) => `/web-course-faqs/${id}`,
    DELETE_WEB_COURSE_FAQ: (id) => `/web-course-faqs/${id}`,

    // File management endpoints (S3 via backend)
    FILE_UPLOAD: '/files/upload',
    FILE_LIST: '/files/list',
    FILE_LIST_RECURSIVE: '/files/list-recursive',
    FILE_DOWNLOAD: '/files/download',
    FILE_DOWNLOAD_FOLDER: '/files/download-folder',
    FILE_DELETE: '/files/delete',
    FILE_DELETE_FOLDER: '/files/delete-folder',

    // Exam User Retake endpoints
    CREATE_EXAM_USER_RETAKE: '/exam-user-retakes/create',
    GET_EXAM_USER_RETAKE_BY_ID: (id) => `/exam-user-retakes/${id}`,
    GET_EXAM_USER_RETAKE_BY_EXAM_AND_USER: (examId, userId) => `/exam-user-retakes/exam/${examId}/user/${userId}`,
    GET_ALL_EXAM_USER_RETAKES: '/exam-user-retakes/all',
    GET_EXAM_USER_RETAKES_BY_EXAM_ID: (examId) => `/exam-user-retakes/exam/${examId}`,
    GET_EXAM_USER_RETAKES_BY_USER_ID: (userId) => `/exam-user-retakes/user/${userId}`,
    GET_RETAKES_BY_EXAM_ID: (examId) => `/exam-user-retakes/exam/${examId}/retakes`,
    UPDATE_EXAM_USER_RETAKE: (id) => `/exam-user-retakes/update/${id}`,
    UPDATE_EXAM_USER_RETAKE_IS_RETAKE: (id) => `/exam-user-retakes/update-retake/${id}`,
    DELETE_EXAM_USER_RETAKE: (id) => `/exam-user-retakes/delete/${id}`,
    DELETE_EXAM_USER_RETAKES_BY_EXAM_ID: (examId) => `/exam-user-retakes/exam/${examId}`,
    DELETE_EXAM_USER_RETAKES_BY_USER_ID: (userId) => `/exam-user-retakes/user/${userId}`,
  };
  
export default API_ENDPOINTS;  
